"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutMode = void 0;
var CheckoutMode;
(function (CheckoutMode) {
    CheckoutMode["post"] = "post";
    CheckoutMode["redirect"] = "redirect";
})(CheckoutMode = exports.CheckoutMode || (exports.CheckoutMode = {}));
